
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';

// utilities
import cx from 'classnames';
import {find, get} from 'lodash';

// components
import ApplicationProgress from './f_ApplicationProgress';
import ApplicationForm from './r_ApplicationForm';

// view ordering array of arrays
import {viewOrderArr} from '../viewOrderArr';


export default function Application(props) {
  const currentNav = find(viewOrderArr, (v) => v.key === props.activeColumnNav);
  const hideSubNavSubmitted = get(currentNav, 'hideSubNavSubmitted', false) && props.submitted;
  const showProgress = !!props.rowSubNav.length && !hideSubNavSubmitted;
  const activeColumnNav = (props.activeColumnNav || '').toLowerCase();
  return (
    <div className='application-container clearfix'>
      {
        showProgress
        &&
        <ApplicationProgress
          className={activeColumnNav}
          updateRowSubNav={props.navStateChange.bind(this, props.activeColumnNav)}
          {...props}
        />
      }

      {
        !props.assessment ?
        <ApplicationForm
          className={cx({'progress-is-showing': showProgress})}
          {...props}
        /> : null
      }

    </div>
  );
}

Application.propTypes = {
  navStateChange: PropTypes.func,
  activeColumnNav: PropTypes.string,
  rowSubNav: PropTypes.array
};

Application.defaultProps = {
  rowSubNav: []
};



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/index.js